// `teacher_area` gates the "Área do professor" tab of the redesigned
// Modalidades page (`ModalitiesPage`, itself behind `new_modalities_page`):
// the teacher's classes ordered by the next session, searchable, plus
// indicators over them. Seed migration: amsm-backend
// hall/feature_flags/migrations/0023_seed_teacher_area_flag.py — off for
// every tenant until an administrator turns it on. The backend endpoints
// re-check it.
export const TEACHER_AREA_FLAG = 'teacher_area'
